<div class="recentes-container">
  <h2 class="recentes-title">Recentes</h2>
  <div class="recentes-list">
    @for (doc of documento; track doc.tipoDocumento) {
      <p class="recente-empresa">{{ doc.empresa }}</p>
      <div class="recente-item">
        <div class="recente-row">
          <div class="recente-left">
            <p class="recente-empresa" [title]="doc.nomeArquivo">{{ doc.nomeArquivo }}</p>
            <p class="recente-empresa">{{ doc.tipoDocumento }}</p>
          </div>
          <div class="recente-right">
            <span class="recente-text-right recente-data">{{ formatarDataHora(doc.data) }}</span>
            <div class="recente-usuario-container">
              <span class="recente-text-right recente-usuario-label">Usuário Envio</span>
              <span class="recente-text-right recente-usuario">{{ getPrimeiroUltimoNome(doc.usuarioEnvio) }}</span>
            </div>
          </div>
        </div>
        <div class="recente-separator"></div>
      </div>
    } @empty {
      <p class="recentes-empty">Nenhum item recente encontrado.</p>
    }
  </div>
</div>
